import { Col, Row } from 'antd';
import { withRouter } from 'next/router';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import SearchResults from '@/src/compliance/components/CompliAssist/SearchResults';
import {
  requestSearchOptions,
  updateSearchFilters,
} from '@/src/compliance/redux/complianceReducer';
import Form from '@/src/shared/components/Form';

import SearchFilters from './SearchFilters';
import TagTile from './SearchFilters/TagTile';

const FIELD_NAMES = {
  SEARCH: 'SearchText',
  STATE: 'States',
  CATEGORY: 'Categories',
  CHART: 'Charts',
};

class CompliAssistChartSearch extends Component {
  state = {
    filterExpanded: true,
    [`tags_${FIELD_NAMES.SEARCH}`]: [],
    [`tags_${FIELD_NAMES.STATE}`]: [],
    [`tags_${FIELD_NAMES.CHART}`]: [],
    [`tags_${FIELD_NAMES.CATEGORY}`]: [],
    modalVisible: false,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  resetTags = () => {
    this.setState({
      [`tags_${FIELD_NAMES.SEARCH}`]: [],
      [`tags_${FIELD_NAMES.STATE}`]: [],
      [`tags_${FIELD_NAMES.CHART}`]: [],
      [`tags_${FIELD_NAMES.CATEGORY}`]: [],
    });
  };

  getSelectionState = (value, selectedNodes, input, isInitialVal = false) => {
    const newState = {};
    const tagInput = `tags_${input}`;
    if (isInitialVal) {
      newState[tagInput] = selectedNodes;
    } else if (selectedNodes && Array.isArray(selectedNodes)) {
      const selections = selectedNodes.map(nd => ({ ...nd.props, input }));
      newState[tagInput] = selections;
    } else {
      const selectedProps = selectedNodes && selectedNodes.props;
      const text = selectedProps ? selectedProps.children : value;
      newState[tagInput] = value ? [{ value, input, children: text }] : [];
    }
    return newState;
  };

  setSelection = (...args) => {
    const newState = this.getSelectionState(...args);
    this.setState(newState);
  };

  setSelectionTags = tags => {
    const newState = tags.reduce((acc, tag) => {
      const tagState = this.getSelectionState(...tag);
      Object.assign(acc, tagState);
      return acc;
    }, {});
    this.setState(newState);
  };

  handleFiltersCollapseChange = activeTabs => {
    this.setState({ filterExpanded: activeTabs.includes('1') });
  };

  tagClose = (e, value, input) => {
    e.preventDefault();
    const { form, updateSearchFilters: updateSearch } = this.props;
    const storedValue = form.getFieldValue(input);
    let selections = '';
    if (Array.isArray(storedValue)) {
      selections = storedValue.filter(v => v !== value);
      this.setState(state => {
        return {
          [`tags_${input}`]: state[`tags_${input}`].filter(tag => selections.includes(tag.value)),
        };
      });
    } else {
      this.setState({ [`tags_${input}`]: [] });
    }
    form.setFieldsValue({ [input]: selections });
    updateSearch(input, selections);
  };

  render() {
    const {
      form,
      searchParams,
      searchFilterKey,
      searchOptions: {
        FieldOptions: { Categories, Charts, States },
      },
      searchFiltersValues,
    } = this.props;
    const { filterExpanded } = this.state;

    const filterTags = [];

    Object.values(FIELD_NAMES).forEach(k => {
      const localState = this.state;
      const tagName = `tags_${k}`;
      const tag = localState[tagName];
      // Add local state tag
      if (tag && Array.isArray(tag) && tag.length > 0) {
        filterTags.push(...tag);
      } else if (tag && tag.input) {
        filterTags.push(tag);
      }
      // If local state not import yet for searchId query, merge tags with searchFiltersReducer
      const fieldValue = searchFiltersValues[k];
      if (k === FIELD_NAMES['SEARCH'] && fieldValue) {
        const searchState = {
          value: fieldValue,
          input: k,
          children: fieldValue,
        };
        if (!filterTags.find(({ input }) => input === k)) {
          filterTags.push(searchState);
        }
      }
      if (k === FIELD_NAMES['STATE'] && Array.isArray(fieldValue)) {
        fieldValue.forEach(v => {
          const selectedState = States.find(s => s.StateCode === v);
          if (selectedState) {
            const formattedState = {
              value: v,
              children: selectedState.StateDescription,
              input: k,
            };
            if (!filterTags.find(({ input, value }) => input === k && value === v)) {
              filterTags.push(formattedState);
            }
          }
        });
      }
      if (k === FIELD_NAMES['CATEGORY'] && fieldValue) {
        const selectedCategory = Categories.find(c => c.CategoryId === fieldValue);
        if (selectedCategory) {
          const formattedCategoryTag = {
            value: fieldValue,
            children: selectedCategory.CategoryDescription,
            input: k,
          };
          if (!filterTags.find(({ input }) => input === k)) {
            filterTags.push(formattedCategoryTag);
          }
        }
      }
      if (k === FIELD_NAMES['CHART'] && Array.isArray(fieldValue)) {
        fieldValue.forEach(v => {
          const selectedChart = Charts.find(c => c.ChartId === v);
          if (selectedChart) {
            const formattedChartTag = {
              value: v,
              children: selectedChart.ChartTitle,
              input: k,
            };
            if (!filterTags.find(({ input, value }) => input === k && value === v)) {
              filterTags.push(formattedChartTag);
            }
          }
        });
      }
    });

    return (
      <Row gutter={{ xs: 24, md: 32 }} type="flex">
        <Col xs={24} lg={filterExpanded ? 8 : 24}>
          <SearchFilters
            form={form}
            filterExpanded={filterExpanded}
            setSelection={this.setSelection}
            setSelectionTags={this.setSelectionTags}
            handleCategoryChange={this.handleCategoryChange}
            searchFilterKey={searchFilterKey}
            handleFiltersCollapseChange={this.handleFiltersCollapseChange}
            searchParams={searchParams}
            onSaveSearch={() => { }}
            resetTags={this.resetTags}
            includeDates={false}
            rootSearchURL="/compliance/compliassist"
          />
          {!filterExpanded &&
            filterTags.map(tag => <TagTile key={tag.value} tag={tag} tagClose={this.tagClose} />)}
        </Col>
        <Col xs={24} lg={filterExpanded ? 16 : 24}>
          {/* DO NOT DELETE CLASSNAME. IT IS NECESSSARY FOR THE COLLAPSE ALL AND EXPAND ALL FUNCTIONS. */}
          <div className="accordion-panels-container">
            <SearchResults displayChanges={false} />
          </div>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  const {
    compliance: { searchOptions, searchFiltersValues },
  } = state;

  return {
    searchOptions,
    searchFiltersValues,
  };
}
export default connect(
  mapStateToProps,
  { requestSearchOptions, updateSearchFilters }
)(Form.create({ name: 'CompliAssistChartSearch' })(withRouter(CompliAssistChartSearch)));
